import { render } from "./cart-samples.vue?vue&type=template&id=4fb7dc13"
import script from "./cart-samples.vue?vue&type=script&lang=js"
export * from "./cart-samples.vue?vue&type=script&lang=js"

import "./cart-samples.vue?vue&type=style&index=0&id=4fb7dc13&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__